var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { container } from 'tsyringe';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LanguageService } from 'services/LanguageService';
import BallLoader from 'ui/v1/loaders/BallLoader.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import ENV from 'config/env';
var EmailRedirect = /** @class */ (function (_super) {
    __extends(EmailRedirect, _super);
    function EmailRedirect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        return _this;
    }
    EmailRedirect.prototype.setAnalyticsConfiguration = function () {
        var _a, _b, _c;
        this.$app.stonehengeLogger.start({
            domain: this.domain,
            serverApiRoot: ENV.JOBILLA_API_ROOT.slice(0, -1),
            context: {
                actorId: (_a = this.actorId) !== null && _a !== void 0 ? _a : null,
                emitterId: (_b = this.emitterId) !== null && _b !== void 0 ? _b : null,
                emitterType: (_c = this.emitterType) !== null && _c !== void 0 ? _c : null,
            },
        });
    };
    EmailRedirect.prototype.mounted = function () {
        var _a;
        if (!this.domain) {
            this.$app.redirectToHome();
        }
        this.setAnalyticsConfiguration();
        this.$app.stonehengeLogger.log((_a = this.eventId) !== null && _a !== void 0 ? _a : null);
        this.loading = false;
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmailRedirect.prototype, "domain", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmailRedirect.prototype, "actorId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmailRedirect.prototype, "emitterId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmailRedirect.prototype, "emitterType", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmailRedirect.prototype, "eventId", void 0);
    EmailRedirect = __decorate([
        Component({
            components: {
                BallLoader: BallLoader,
                Icon: Icon,
            },
            beforeRouteEnter: function (to, from, next) {
                var _a;
                container.resolve(LanguageService).setLanguage((_a = to.query.lang) !== null && _a !== void 0 ? _a : 'en-GB');
                return next();
            },
            beforeDestroy: function () {
                this.$app.stonehengeLogger.destroyInstance();
            },
        })
    ], EmailRedirect);
    return EmailRedirect;
}(Vue));
export default EmailRedirect;
